<template>
  <a-spin tip="加载中..." :spinning="isFormLoaded">
    <a-form class="artist-form-detail" :form="form" @submit="handleSubmit">
      <a-form-item label="新闻 ID" v-bind="formItemLayout">
        <a-input class="form-input" v-decorator="decorator.news_id" disabled>
        </a-input>
      </a-form-item>

      <a-form-item label="语言" v-bind="formItemLayout">
        <a-select class="form-input" v-decorator="decorator.language">
          <a-select-option
            v-for="(item, key) in langList"
            :value="item.id"
            :key="key"
          >
            {{ item.lang }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="封面图" v-bind="formItemLayout">
        <v-image-upload
          v-decorator="decorator.cover"
          rootPath="news"
        ></v-image-upload>
      </a-form-item>

      <a-form-item label="新闻标题：" v-bind="formItemLayout">
        <a-input
          class="form-input"
          v-decorator="decorator.title"
          placeholder="请输入新闻标题"
        ></a-input>
      </a-form-item>

      <a-form-item label="新闻简介：" v-bind="formItemLayout">
        <a-textarea
          v-decorator="decorator.summary"
          :rows="4"
          placeholder="请输入新闻简介"
        />
      </a-form-item>

      <a-form-item label="新闻介绍：" v-bind="formItemLayout">
        <v-text-editor v-decorator="decorator.content"></v-text-editor>
      </a-form-item>

      <a-form-item v-bind="formBtnLayout">
        <a-button type="primary" html-type="submit">
          提交
        </a-button>
        <a-button class="back-btn" @click="$router.push('/news')">
          返回
        </a-button>
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import TextEditor from '@/components/TextEditor'
import ImageUpload from '@/components/ImageUpload'

const decorator = {
  news_id: ['news_id'],
  language: [
    'language',
    { initialValue: 1 },
    { rules: [{ required: true, message: '请选择新闻详情对应的语言！' }] }
  ],
  cover: [
    'cover',
    { rules: [{ required: true, message: '必须上传新闻封面！' }] }
  ],
  title: [
    'title',
    { rules: [{ required: true, message: '请输入新闻标题！' }] }
  ],
  summary: [
    'summary',
    { rules: [{ required: true, message: ' 请输入新闻简介！' }] }
  ],
  content: [
    'content',
    { rules: [{ required: true, message: ' 请输入新闻介绍！' }] }
  ]
}

const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 15 }
}

const formBtnLayout = {
  wrapperCol: { span: 8, offset: 5 }
}

export default {
  name: 'ArtistFormDetail',

  props: {
    isFormLoaded: { type: Boolean },
    langList: { type: Array },
    formData: { type: Object },
    handleFormSubmit: { type: Function }
  },

  components: {
    'v-text-editor': TextEditor,
    'v-image-upload': ImageUpload
  },

  created() {
    this.form = this.$form.createForm(this)
  },

  mounted() {
    this.form.setFieldsValue({
      news_id: Number(this.$route.params.newsID)
    })
  },

  watch: {
    formData(val) {
      this.form.setFieldsValue({
        language: val.language,
        cover: val.cover,
        title: val.title,
        summary: val.summary,
        content: val.content
      })
    }
  },

  data() {
    return {
      decorator,
      formItemLayout,
      formBtnLayout
    }
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) this.handleFormSubmit(values)
      })
    }
  }
}
</script>

<style lang="scss">
.artist-form-detail {
  .form-input {
    width: 150px;
  }
  .back-btn {
    margin-left: 8px;
  }
}
</style>
